/**
 * A class containing all the information about the WaysOfBuying
 */
export class WaysOfBuying {
    /**
     * Create a new WaysOfBuying object
     * @param {LabelValue} currentValue
     * @param {string[]} availableOptions
     */
    constructor(currentValue, availableOptions) {
        this._currentValue = currentValue;
        this._availableOptions = availableOptions;
    }

    /**
     * Get an JS object containing all the information about the WaysOfBuying.
     * @return {{currentValue: LabelValue, availableOptions: []}}
     */
    getWayOfBuying() {
        return {
            currentValue: this._currentValue,
            availableOptions: this._availableOptions,
        };
    }

    /**
     * Get the current value
     * @return {LabelValue}
     */
    get currentValue() {
        return this._currentValue;
    }

    /**
     * Get the available options
     * @return {string[]}
     */
    get availableOptions() {
        return this._availableOptions;
    }
}
